import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from '../common/Modal';
import { redirectService } from '../../utils/redirect';

const AuthModal = ({ isOpen, onClose, action = 'access this feature', fundingId = null}) => {
  const location = useLocation();

  const handleAuthNavigation = (authType) => {
    redirectService.setRedirectIntent({
      returnTo: location.pathname,
      action,
      fundingId,
      timestamp: Date.now(),
    });
    onClose();
  };


  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create a free account">
      <div className="text-center">
        {/* Icon */}
        <div
          className="mx-auto w-12 h-12 rounded-full flex items-center justify-center mb-4"
          style={{ backgroundColor: 'rgba(97, 93, 236, 0.1)' }}
        >
          <svg
            className="w-6 h-6"
            style={{ color: '#615DEC' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </div>

        {/* Headline */}
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Sign up for free to continue
        </h3>

        {/* Description */}
        <p className="text-gray-600 mb-6">
          Create a free account to {action}. It only takes a few seconds, and you can save and revisit opportunities anytime.
        </p>

        {/* Primary CTA: Sign Up */}
        <div className="space-y-3">
          <Link
            to="/signup"
            onClick={() => handleAuthNavigation('signup')}
            className="w-full bg-[#615DEC] text-white py-3 px-6 rounded-md font-medium hover:bg-[#4c47c7] transition-colors block text-center"
          >
            Sign up for free
          </Link>

          {/* Secondary CTA: Sign In */}
          <p className="text-sm text-gray-600 mt-2">
            Already have an account?{' '}
            <Link
              to="/login"
              onClick={() => handleAuthNavigation('login')}
              className="font-medium hover:underline"
              style={{ color: '#615DEC' }}
              onMouseEnter={(e) => (e.target.style.color = '#4c47c7')}
              onMouseLeave={(e) => (e.target.style.color = '#615DEC')}
            >
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AuthModal;